import { render, staticRenderFns } from "./promoted.vue?vue&type=template&id=730b44aa&"
import script from "./promoted.vue?vue&type=script&lang=ts&"
export * from "./promoted.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports